import React from "react";
import {SocialInsight, SocialInsightRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Grid} from "@mui/material";
import {FormModel, useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";

export const SocialInsightEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(SocialInsightRestControllerApiFactory);

    const form: FormModel<SocialInsight> = useForm({
        fetcher: (id) => ctrl.getSocialInsight(id),
        updater: (bean) => ctrl.saveSocialInsight(bean),
        remover: (id) => ctrl.deleteOrDismissSocialInsight(id),
        factory: () => ({} as SocialInsight),
    } as UseFormProps<SocialInsight>);

    return (
        <FormContent form={form} title={"Métrica"}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={3}><FormInput field={"impressions"} label={"Impresiones"} type="number" disabled/></Grid>
                <Grid item xs={12} sm={3}><FormInput field={"reach"} label={"Alcance"} type="number" disabled/></Grid>
                <Grid item xs={12} sm={3}><FormInput field={"clicks"} label={"Clics"} type="number" disabled/></Grid>
                <Grid item xs={12} sm={3}><FormInput field={"engagement"} label={"Interacciones"} type="number" disabled/></Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={3}><FormInput field={"likes"} label={"Me gusta"} type="number" disabled/></Grid>
                <Grid item xs={12} sm={3}><FormInput field={"comments"} label={"Comentarios"} type="number" disabled/></Grid>
                <Grid item xs={12} sm={3}><FormInput field={"shares"} label={"Compartidos"} type="number" disabled/></Grid>
                <Grid item xs={12} sm={3}><FormInput field={"capturedAt"} label={"Capturado"} type="datetime" disabled/></Grid>
            </Grid>
            <FormInput field={"raw"} label={"Respuesta cruda (diagnóstico)"} rows={6} disabled/>
        </FormContent>
    );
};
